import { combineReducers } from 'redux';

import { appDataReducerKey, appDataReducer } from './reducer';
import { pdpReducerKey, pdpReducer } from 'shared/components/ProductDetailsPageV2';

import {
  couponBannerReducerKey,
  couponBannerReducer
} from 'screens/Studio/Studio/components/StudioBanner/state';

import {
  assistantReducerKey,
  assistantReducer
} from 'screens/Studio/Studio/components/Assistant/state';

import {
  bessieModalReducer,
  bessieModalReducerKey
} from 'screens/Studio/Studio/components/BessieChangesModal/state';

import {
  designFeedbackReducerKey,
  designFeedbackReducer
} from 'screens/Studio/Studio/components/DesignFeedback/state';

import {
  designViewerReducerKey,
  designViewerReducer
} from 'redux/Studio/DesignViewer';

import {
  productBrowserReducerKey,
  productBrowserReducer
} from 'redux/StudioProductBrowser';

import {
  reducerKey as swapProductsReducerKey,
  reducer as swapProductsReducer
} from 'redux/Studio/SwapProducts';

import {
  reducerKey as studioShowroomReducerKey,
  reducer as studioShowroomReducer
} from 'screens/Studio/Studio/components/StudioShowroom_PROTOTYPE/state';

import {
  studioFeedbackReducerKey,
  studioFeedbackReducer
} from 'screens/Studio/Studio/components/StudioFeedback/state';

import {
  studioRedesignRequestsReducerKey,
  studioRedesignRequestsReducer
} from 'screens/Studio/Studio/components/StudioRedesignRequests/state';

export const studioReducerKey = 'liveswap';
export const studioReducer = combineReducers({
  [appDataReducerKey]: appDataReducer,
  [assistantReducerKey]: assistantReducer,
  [bessieModalReducerKey]: bessieModalReducer,
  [couponBannerReducerKey]: couponBannerReducer,
  [designFeedbackReducerKey]: designFeedbackReducer,
  [designViewerReducerKey]: designViewerReducer,
  [pdpReducerKey]: pdpReducer,
  [productBrowserReducerKey]: productBrowserReducer,
  [studioShowroomReducerKey]: studioShowroomReducer,
  [swapProductsReducerKey]: swapProductsReducer,
  [studioFeedbackReducerKey]: studioFeedbackReducer,
  [studioRedesignRequestsReducerKey]: studioRedesignRequestsReducer
});

export const getStateSliceFor = ({ state, reducerKey }) => {
  return state[studioReducerKey][reducerKey];
};

export * from './actions'; // eslint-disable-line
export * from './selectors'; // eslint-disable-line
